var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoginLoading,
          expression: "isLoginLoading",
        },
      ],
      ref: "loginForm",
      staticClass: "login-form",
      attrs: {
        rules: _vm.loginRules,
        model: _vm.loginForm,
        "label-width": "0",
      },
    },
    [
      _c(
        "el-form-item",
        { staticClass: "phone-input", attrs: { prop: "userPhone" } },
        [
          _c(
            "el-select",
            {
              staticClass: "phone-area-code",
              attrs: {
                size: "medium",
                filterable: "",
                placeholder: "请选择",
                "popper-class": "phone-area-code-select",
              },
              model: {
                value: _vm.loginForm.userPhonePrefix,
                callback: function ($$v) {
                  _vm.$set(_vm.loginForm, "userPhonePrefix", $$v)
                },
                expression: "loginForm.userPhonePrefix",
              },
            },
            _vm._l(_vm.areaCodeList, function (item) {
              return _c(
                "el-option",
                {
                  key: item.id,
                  attrs: { label: item.dictLabel, value: item.id },
                },
                [
                  _c("span", [_vm._v("+" + _vm._s(item.dictCode))]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { float: "right" } }, [
                    _vm._v(_vm._s(item.dictName)),
                  ]),
                ]
              )
            }),
            1
          ),
          _c(
            "el-input",
            {
              staticClass: "phone-input",
              attrs: {
                "auto-complete": "off",
                size: "large",
                placeholder: "请输入手机号",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleRegister($event)
                },
              },
              model: {
                value: _vm.loginForm.userPhone,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.loginForm,
                    "userPhone",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "loginForm.userPhone",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-phone",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "smsVerifyCode-input",
          attrs: { prop: "smsVerifyCode" },
        },
        [
          _c(
            "el-input",
            {
              attrs: {
                size: "large",
                "auto-complete": "off",
                placeholder: "请输入验证码",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleLogin($event)
                },
              },
              model: {
                value: _vm.loginForm.smsVerifyCode,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.loginForm,
                    "smsVerifyCode",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "loginForm.smsVerifyCode",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-unlock",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
          _c(
            "el-button",
            {
              class: [{ display: _vm.sendSmsFlag }],
              attrs: { size: "large" },
              on: { click: _vm.handleSend },
            },
            [_vm._v(_vm._s(_vm.msgText))]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "login-submit",
                      style: {
                        background: "" + _vm.icontitleLoginButton,
                        borderColor: "" + _vm.icontitleLoginButton,
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleLogin },
                    },
                    [_vm._v("登录 ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "login-submit",
                      style: {
                        background: "" + _vm.icontitleLoginButton,
                        borderColor: "" + _vm.icontitleLoginButton,
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleRegister },
                    },
                    [_vm._v("注册 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }